"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.options = void 0;
var defaultProps = {
    placeholder: 'add more people...',
};
var Options = /** @class */ (function () {
    function Options() {
        this.props = defaultProps;
    }
    Options.prototype.setProps = function (optionalProps) {
        this.props = __assign(__assign({}, this.props), optionalProps);
    };
    Options.prototype.getProps = function () {
        return this.props;
    };
    return Options;
}());
exports.options = new Options();
